<template>
  <v-navigation-drawer
    id="default-drawer"
    v-model="drawer"
    :dark="dark"
    :right="rtl"
    :src="drawerImage ? image : ''"
    :mini-variant.sync="mini"
    mini-variant-width="80"
    app
    width="260"
  >
    <template
      v-if="drawerImage"
    >
      <v-img
        :key="image"
        :gradient="gradients[1]"
      />
    </template>

    <div class="px-2">
      <default-drawer-header />

      <v-divider class="mx-3 mb-2" />

      <v-treeview v-if="getLoggedIn" :items="menu">
        <template slot="label" slot-scope="props">
          <router-link :to="props.item.to" v-if="props.item.to">{{ props.item.name }}</router-link>
          <span v-else>{{ props.item.name }}</span>
      </template>
      </v-treeview>
    </div>

    <template #append>
      <div class="pa-4 text-center">
        
      </div>
    </template>

    <div class="pt-12" />
  </v-navigation-drawer>
</template>

<script>

  export default {
    name: 'DefaultDrawer',

    components: {
      DefaultDrawerHeader: () => import(
        /* webpackChunkName: "default-drawer-header" */
        './widgets/DrawerHeader'
      ),
    },
    data() {
      return {
        dark: true,
        gradients: [
            'rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)',
            'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)',
            'rgba(244, 67, 54, .8), rgba(244, 67, 54, .8)',
          ],
        image: null,
        mini: false,     
        menu: []
      }
    },
    methods: {
      
      getApotheken() {

        let apoId = -1;

        if (this.$store.getters.getApotheke) {
          apoId = this.$store.getters.getApotheke.id;
        }
        else {
          apoId = parseInt(this.$route.params.id);
        }

        let result = [          
        {
            id: 2,
            name: "Übersicht",
            to: "/dashboard/" + apoId,
        },
        {
            id: 3,
            name: "Lager",
            children: [
              { 
                id: 4, 
                name: "Lagerentwicklung",
                to: "/lagerentwicklung/" + apoId,
              },
              { 
                id: 5, 
                name: "Lagerverteilung",
                to: "/lagerverteilung/" + apoId,
              },
              { 
                id: 12, 
                name: "Lagerumschlag",
                to: "/lagerumschlag/" + apoId,
              },
            ],
        },
        {
            id: 6,
            name: "Verkauf",
            children: [              
              { 
                id: 13, 
                name: "Entw. Packungen",
                to: "/abgegebenePackungen/" + apoId,
              },
              { 
                id: 7, 
                name: "Entw. Lieferfähigkeit",
                to: "/lieferfaehigkeitEntwicklung/" + apoId,
              },
              { 
                id: 8, 
                name: "Verteilung Besorger",
                to: "/verteilungBesorger/" + apoId,                
              },
              { 
                id: 11, 
                name: "Verteilung Verkäufe",
                to: "/verkaufVerteilung/" + apoId,                
              }
            ],
        },
        {
            id: 9,
            name: "Einkauf",
            children: [
              { 
                id: 10, 
                name: "Entw. Wareneingang",
                to: "/wareneingangEntwicklung/" + apoId,
              },
            ],
        },
        {
            id: 18,
            name: "Direktbevorratung",
            to: "/direktbevorratung/" + apoId,
        },
        {
            id: 14,
            name: "Einstellungen",
            children: [
              { 
                id: 15, 
                name: "Lagerorte",
                to: "/lagerorte/" + apoId,
              },
              { 
                id: 16, 
                name: "Kühl/BTM",
                to: "/kuehlbtm/" + apoId,
              },
              { 
                id: 17, 
                name: "Listungsgrenzen",
                to: "/listungsgrenzen/" + apoId,
              },
            ],
        }
      ];

        if (this.$store.getters.getRole == "admin") {
          result.unshift(
            { id: 1, name: 'Apothekenauswahl', to: '/Pharmacies' }
          );
        }
        if (this.$store.getters.getRole == "admin") {
          result.push(
            { id: 101, name: 'Verwaltungsdashboard', to: '/administrationOverview' }
          );
        }
        if (this.$store.getters.getRole == "admin") {
          result.push(
            { id: 100, name: 'Benutzerverwaltung', to: '/useradministration' }
          );
        }
        this.menu = result;
      },
    },
    computed: {
      //mini() {
      //  return this.$store.state.mini;
      //},
      drawer: {
        get () {
          return this.$store.state.drawer;
        },
        set (value) {
          this.$store.commit('changeDrawer', value);
        },
      },
      drawerImage() {
        return this.$store.state.drawerImage;
      },
      rtl() {
        return this.$store.state.rtl;
      },
      getLoggedIn() {
        return this.$store.state.loggedIn;
      }
    },
    created() {
      this.$eventHub.$on('apothekeSelected', this.getApotheken);
      this.getApotheken();
    },
    beforeDestroy() {
      this.$eventHub.$off('apothekeSelected');
    },
  }
</script>

<style scoped>
a:link {
  color: #fff;
  text-decoration: none;
}
a:visited {
  color: #fff;
  text-decoration: none;
}
a:hover {
  color: #fff;
  text-decoration: none;
}
a:active {
  color: #fff;
  text-decoration: none;
}
.router-link-exact-visited {    
  color: #fff;
  text-decoration: none;
}
.router-link-exact-active {
  color: #fff;
  text-decoration: underline;
}
</style>
